import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import messages from '../../messages'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import Accordion from '@material-ui/core/Accordion'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import {
  TubeProduct,
  Modification,
  TubeProperties,
  CountryType,
  probeTypes,
} from '../../utils/StandardMTOEnum'
import { configContext } from '../../utils/StandardReducer'
import ValidationErrors from '../../validations/ValidationErrors'
import {
  getNterminalDefaultValue,
  getCterminalDefaultValue,
  getDefaultRNAModValue,
} from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import { checkValidKey } from '@src/routes/Configurators/utils/util'
import { useRouter } from 'next/router'
import { isEmpty, isNil } from 'lodash'

export enum DefaultValue {
  categoryNterminalType = 'nterminalMod',
  categoryCterminalType = 'cterminalMod',
  categoryTypeValue = 'fluorescent',
  categoryTypeLongOligoValue = '',
  categoryThreeModType = 'threeMod',
  categoryFiveModType = 'fiveMod',
}
const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5),
    },
    panelSummary: {
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0),
      fontSize: theme.typography.pxToRem(16),
    },
    expanded: {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },
    widthFillContent: {
      width: 'fit-content',
      display: 'inline-table',
    },
    activePanelIcon: {
      color: theme.palette.primary.main,
      position: 'absolute',
    },
    panelDetails: {
      display: 'inherit',
    },
    panelContainer: {
      marginTop: theme.spacing(0.5),
      boxShadow: 'none',
      '&:before': {
        opacity: 0,
      },
    },
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1.5),
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    radio: {
      padding: theme.spacing(1),
    },
    specificationsWrapper: {
      '& span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    textWrapper: {
      '& label span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    showMorePanel: {
      margin: 0,
    },
    mgLeft: {
      marginLeft: theme.spacing(-9),
    },
    add: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    labelSpacing: {
      marginTop: theme.spacing(6),
      marginLeft: theme.spacing(-4),
    },
    labelSpacingnterm: {
      marginTop: theme.spacing(13),
      marginLeft: theme.spacing(-4),
    },
    marginArrangement: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(-10),
      marginTop: theme.spacing(-9),
      marginLeft: theme.spacing(-5),
    },
    marginArrangementCTerminal: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(-4),
      marginTop: theme.spacing(-9),
      marginLeft: theme.spacing(-5),
    },
  }
})
export const getInternalModFromSeq = (sessionData, currentOligoIndex) => {
  const match = sessionData[currentOligoIndex].sequence.match(/\[BHQ\d+\]/)
  return match ? match[0] : null
}
export const insertInternalMod = (
  sequence,
  internalMod,
  probeType,
  isValidationOverriden
) => {
  const baseRegex = /(\[.*?\])|([ACGT])/g
  let baseCount = 0
  let insertIndex = -1

  // Determine the correct position to insert the internal modification
  sequence.replace(baseRegex, (match, p1, p2, offset) => {
    baseCount++
    if (baseCount === 9 && insertIndex === -1) {
      insertIndex = offset + match.length
    }
  })

  // Insert the internal modification if the position is found and the sequence length is appropriate
  if (
    (insertIndex !== -1 &&
      baseCount >= 10 &&
      baseCount <= 50 &&
      probeType === 'internalquench') ||
    probeType === 'dualquench' ||
    (isValidationOverriden && baseCount > 50)
  ) {
    const regex = /\[BHQ[^\]]*\]/g
    const containsMod = regex.test(sequence)
    if (!containsMod) {
      return `${sequence.slice(0, insertIndex)}${
        internalMod || ''
      }${sequence.slice(insertIndex)}`
    } else {
      const newSeq = sequence.replace(/\[BHQ[^\]]*\]/g, '')
      return `${newSeq.slice(0, insertIndex)}${internalMod || ''}${newSeq.slice(
        insertIndex
      )}`
    }
  }

  return sequence
}

const Modifications = (props) => {
  const router = useRouter()
  const classes = useStyles()
  const GlobalCSS = styles()
  const { modificationResponseData, productDetails, modificationType } = props

  const { state, dispatch } = React.useContext(configContext)
  const {
    sessionData,
    currentOligoIndex,
    isSequenceValid,
    isDeletePerform,
    errorData,
    errorResponseJson,
    isTubePageLoad,
  } = state
  const [disabled, setDisabled] = React.useState(true)

  const reporterQuencherMod = `${sessionData[currentOligoIndex].fiveMod}${
    sessionData[currentOligoIndex].internalMod
      ? sessionData[currentOligoIndex].internalMod
      : ''
  }/${sessionData[currentOligoIndex].threeMod}`
  const [reporterQuencherValue, setReporterQuencherValue] = React.useState(
    reporterQuencherMod ? reporterQuencherMod : ''
  )
  const [lessButton, setLessButton] = React.useState(false)
  let defaultNterminal = ''
  let defaultCterminal = ''
  let defaultThreeMod = ''
  let defaultFiveMod = ''

  if (productDetails.productType === TubeProduct.Rna) {
    defaultThreeMod = getDefaultRNAModValue(
      DefaultValue.categoryThreeModType,
      DefaultValue.categoryTypeValue,
      modificationResponseData
    )

    defaultFiveMod = getDefaultRNAModValue(
      DefaultValue.categoryFiveModType,
      DefaultValue.categoryTypeValue,
      modificationResponseData
    )
  } else if (productDetails.productType === TubeProduct.LongOligo) {
    defaultThreeMod = getDefaultRNAModValue(
      DefaultValue.categoryThreeModType,
      DefaultValue.categoryTypeLongOligoValue,
      modificationResponseData
    )

    defaultFiveMod = getDefaultRNAModValue(
      DefaultValue.categoryFiveModType,
      DefaultValue.categoryTypeLongOligoValue,
      modificationResponseData
    )
  } else {
    defaultFiveMod =
      modificationResponseData.modifications[0]?.category[0]?.modifications[0]
        ?.value
    defaultThreeMod =
      modificationResponseData.modifications[2]?.category[0]?.modifications[0]
        ?.value
  }

  const [fiveModValue, setFiveModValue] = React.useState(
    defaultFiveMod !== null && defaultFiveMod !== undefined
      ? defaultFiveMod
      : Modification.DefaultRnaMod
  )

  const [threeModValue, setThreeModValue] = React.useState(
    defaultThreeMod !== null && defaultThreeMod !== undefined
      ? defaultThreeMod
      : Modification.DefaultRnaMod
  )

  if (productDetails.productType === TubeProduct.Cpeptide) {
    defaultNterminal = getNterminalDefaultValue(
      DefaultValue.categoryNterminalType,
      DefaultValue.categoryTypeValue,
      modificationResponseData
    )

    defaultCterminal = getCterminalDefaultValue(
      DefaultValue.categoryCterminalType,
      DefaultValue.categoryTypeValue,
      modificationResponseData
    )
  } // for other product code will be dynamic later on by other product onwer.
  else {
    defaultNterminal =
      modificationResponseData.modifications[1]?.category[0]?.modifications[0]
        ?.value
    defaultCterminal =
      modificationResponseData.modifications[3]?.category[0]?.modifications[0]
        ?.value
  }

  const [nTerminalModValue, setNTerminalModValue] = React.useState(
    defaultNterminal !== null && defaultNterminal !== undefined
      ? defaultNterminal
      : TubeProperties.DefaultNTerminal
  )

  const [cTerminalModValue, setCTerminalModValue] = React.useState(
    defaultCterminal !== null && defaultCterminal !== undefined
      ? defaultCterminal
      : TubeProperties.DefaultCTerminal
  )

  const [expanded, setExpanded] = React.useState<string | false>(false)

  let quencherMods = []
  let fiveMod = []
  let threeMod = []
  let nterminalMod = []
  let cterminalMod = []
  const [errorValidation, setErrorValidation] = React.useState<string[]>([])

  const nTerminalChange = (event) => {
    const { value } = event.target
    setNTerminalModValue(value)
    sessionData[currentOligoIndex].nterminalMod = value
    state.errorData.nterminalMod = value
    dispatch({ type: 'SET_ERROR_ICON', data: false })

    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({
      type: 'IS_CONFIRM_ORDER',
      data: false,
    })

    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData },
    })
  }

  const cTerminalChange = (event) => {
    const { value } = event.target
    setCTerminalModValue(value)
    sessionData[currentOligoIndex].cterminalMod = value
    state.errorData.cterminalMod = value
    dispatch({ type: 'SET_ERROR_ICON', data: false })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData },
    })
    dispatch({
      type: 'IS_CONFIRM_ORDER',
      data: false,
    })
  }

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false)
      setLessButton(!lessButton)
    }

  React.useEffect(() => {
    setReporterQuencherValue('')
  }, [sessionData[currentOligoIndex].probeType])

  React.useEffect(() => {
    const internalModFromSession = sessionData[currentOligoIndex].internalMod
    const internalMod = internalModFromSession
      ? internalModFromSession
      : getInternalModFromSeq(sessionData, currentOligoIndex)

    if (state.isPageLoad === 4) {
      const { fiveMod, threeMod } = sessionData[currentOligoIndex]
      const { nterminalMod, cterminalMod } = sessionData[currentOligoIndex]
      let isFiveMod = false
      let isThreeMod = false
      if (fiveMod && fiveMod !== '' && fiveMod !== undefined) {
        setFiveModValue(fiveMod)
      } else {
        isFiveMod = true
        setFiveModValue(Modification.DefaultRnaMod)
      }
      if (threeMod && threeMod !== '' && threeMod !== undefined) {
        setThreeModValue(threeMod)
      } else {
        isThreeMod = true
        setThreeModValue(Modification.DefaultRnaMod)
      }
      if (
        productDetails.productType === TubeProduct.Aqua ||
        productDetails.productType === TubeProduct.Cpeptide
      ) {
        if (nterminalMod && nterminalMod !== '' && nterminalMod !== undefined) {
          setNTerminalModValue(nterminalMod)
        } else {
          setNTerminalModValue(TubeProperties.DefaultNTerminal)
        }

        if (cterminalMod && cterminalMod !== '' && cterminalMod !== undefined) {
          setCTerminalModValue(cterminalMod)
        } else {
          setCTerminalModValue(TubeProperties.DefaultCTerminal)
        }
      }
      if (
        (isEmpty(internalMod) || isNil(internalMod)) &&
        isFiveMod &&
        isThreeMod
      ) {
        setReporterQuencherValue('')
      } else {
        if (internalMod) {
          setReporterQuencherValue(`${fiveMod}/${internalMod}/${threeMod}`)
        } else {
          setReporterQuencherValue(`${fiveMod}/${threeMod}`)
        }
      }
      dispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 3,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, fiveMod, threeMod, internalMod },
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  const resetValidation = () => {
    setErrorValidation([])
    dispatch({
      type: 'IS_DELETE_PERFORM',
      data: false,
    })
    dispatch({
      type: 'RESET_SPECIFICATION_ERROR_MSG',
      data: true,
    })
  }
  React.useEffect(() => {
    resetValidation()
    // TODO: need a test before we refactor these dependencies
  }, [isDeletePerform, currentOligoIndex])

  const setModData = (event) => {
    const { name, value } = event.target
    let isReporter = false
    setErrorValidation([])

    if (name === Modification.FiveMod) {
      isReporter = false
      setFiveModValue(value)
    } else if (name === Modification.ThreeMod) {
      isReporter = false
      setThreeModValue(value)
    } else if (name === Modification.QuencherMod) {
      isReporter = true

      const mods = value.split('/')
      const modObj = { fiveMod: '', internalMod: '', threeMod: '' }
      if (mods?.length > 2) {
        modObj.fiveMod = mods[0]
        modObj.internalMod = mods[1]
        modObj.threeMod = mods[2]
      } else {
        modObj.fiveMod = mods[0]
        modObj.threeMod = mods[1]
      }
      setReporterQuencherValue(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...state.errorData,
          fiveMod: modObj.fiveMod,
          threeMod: modObj.threeMod,
          ...(modObj.internalMod && { internalMod: modObj.internalMod }),
          sequence: modObj?.internalMod
            ? insertInternalMod(
                sessionData[currentOligoIndex]?.sequence,
                modObj.internalMod,
                sessionData[currentOligoIndex].probeType ||
                  router.query.probeType,
                sessionData[currentOligoIndex].isOverridden
              )
            : sessionData[currentOligoIndex].sequence,
        },
      })

      sessionData[currentOligoIndex].fiveMod = modObj.fiveMod
      sessionData[currentOligoIndex].threeMod = modObj.threeMod
      sessionData[currentOligoIndex].internalMod = modObj.internalMod
      sessionData[currentOligoIndex].sequence = modObj?.internalMod
        ? insertInternalMod(
            sessionData[currentOligoIndex]?.sequence,
            modObj.internalMod,
            sessionData[currentOligoIndex].probeType || router.query.probeType,
            sessionData[currentOligoIndex].isOverridden
          )
        : sessionData[currentOligoIndex].sequence

      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
    if (!isReporter) {
      dispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...state.errorData, [name]: value },
      })

      sessionData[currentOligoIndex][name] = value

      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
    dispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    dispatch({ type: 'SET_ERROR_ICON', data: false })
  }
  const checkTotalModificationValdiation = (response) => {
    setErrorValidation([])

    const error: string[] = []

    if (response[currentOligoIndex] === undefined) {
      return false
    }

    if (response[currentOligoIndex].listErrors) {
      const { listErrors } = response[currentOligoIndex]

      if (listErrors) {
        listErrors.forEach((obj) => {
          if (
            obj.key === Modification.ModFive ||
            obj.key === Modification.QuencherMOD
          ) {
            error.push(obj.value)
          }
        })
      }
    }
    setErrorValidation(error)

    return null
  }

  const checkModificationValidation = (response) => {
    const error: string[] = []

    if (response.listErrors && response.listErrors.length !== 0) {
      setErrorValidation([])

      response.listErrors.forEach((obj) => {
        const isModError =
          obj.key === Modification.ModFive ||
          obj.key === Modification.QuencherMOD

        const isSingleFiveMod = response.listFiveMod?.length === 1
        const isFromReviewPage = state.isComingFromReviewPage
        const isLnaBaseError =
          obj.value.includes(TubeProperties.LNABaseError) &&
          obj.key === Modification.QuencherMOD

        const modErrorsOnPageLoad =
          isTubePageLoad && isModError && !isSingleFiveMod && !isFromReviewPage

        const modErrorsAfterPageLoad =
          !isTubePageLoad &&
          isModError &&
          obj.value !== TubeProperties.SelectionRequired &&
          !isSingleFiveMod &&
          !isFromReviewPage

        if (modErrorsOnPageLoad || isLnaBaseError || modErrorsAfterPageLoad) {
          error.push(obj.value)
        }
      })
    }

    setErrorValidation(error)
  }

  React.useEffect(() => {
    if (state.totalValidationJSON) {
      checkTotalModificationValdiation(state.totalValidationJSON)
    }
  }, [state.totalValidationJSON])

  React.useEffect(() => {
    if (sessionData[currentOligoIndex].sequence !== '' || isTubePageLoad) {
      checkModificationValidation(state.errorResponseJson)
    } else {
      resetValidation()
    }
  }, [isTubePageLoad, state.errorResponseJson])

  const isRadioButtonDisabled = (data, modificationType) => {
    if (sessionData[currentOligoIndex].isOverridden) {
      return false
    }
    if (
      state.seqLength === 0 ||
      state.seqLength === undefined ||
      !isSequenceValid ||
      data === null
    ) {
      return true
    }

    if (Object.keys(state.errorResponseJson).length !== 0) {
      let list: any = []
      let threeMod: any = []
      let isQuencher = false
      switch (modificationType) {
        case Modification.FiveMod: {
          list = state.errorResponseJson.listFiveMod
          isQuencher = false
          break
        }
        case Modification.ThreeMod: {
          list = state.errorResponseJson.listThreeMod
          isQuencher = false
          break
        }
        case Modification.QuencherMod: {
          list = state.errorResponseJson.listFiveMod
          threeMod = state.errorResponseJson.listThreeMod
          isQuencher = true
          break
        }
        default:
          return false
      }
      if (list === null) {
        return true
      } else if (isQuencher) {
        const arr = data.value.split('/')
        if (list.includes(arr[0]) && threeMod.includes(arr[1])) {
          return false
        }
      } else if (list.includes(data.value)) {
        return false
      }
    }
    return true
  }

  modificationResponseData.modifications !== undefined &&
    modificationResponseData.modifications.forEach((mod) => {
      if (
        productDetails.productType === TubeProduct.Rna ||
        productDetails.productType === TubeProduct.LongOligo
      ) {
        if (mod.modificationType === Modification.FiveMod) {
          mod.category.forEach((data) => {
            fiveMod = data.modifications
          })
        }
        if (mod.modificationType === Modification.ThreeMod) {
          mod.category.forEach((data) => {
            threeMod = data.modifications
          })
        }
      } else if (
        productDetails.productType === TubeProduct.Aqua ||
        productDetails.productType === TubeProduct.Cpeptide
      ) {
        if (mod.modificationType === Modification.NTerminalMod) {
          mod.category.forEach((data) => {
            nterminalMod = data.modifications
          })
        } else if (mod.modificationType === Modification.CTerminalMod) {
          mod.category.forEach((data) => {
            cterminalMod = data.modifications
          })
        }
      } else if (productDetails.productType === TubeProduct.Wellred) {
        if (mod.modificationType === Modification.FiveMod) {
          mod.category.forEach((data) => {
            fiveMod = data.modifications
          })
        }
      } else if (productDetails.productType === TubeProduct.Probe) {
        if (mod.modificationType === Modification.QuencherMod) {
          const modData = mod.category.find((data) => {
            let probeKey

            if (sessionData[currentOligoIndex]?.probeType) {
              if (
                sessionData[currentOligoIndex].probeType ===
                probeTypes.DualLabel
              ) {
                probeKey = probeTypes.Default
              } else {
                probeKey = sessionData[currentOligoIndex].probeType
              }
            } else {
              if (
                router.query.probeType === probeTypes.DualLabel ||
                !router.query.probeType
              ) {
                probeKey = probeTypes.Default
              } else {
                probeKey = router.query.probeType
              }
            }
            return data.categoryName === probeKey
          })
          quencherMods = modData.modifications
        }
      } else {
        if (mod.modificationType === Modification.QuencherMod) {
          mod.category.forEach((data) => {
            quencherMods = data.modifications
          })
        }
      }
    })

  const renderThreeModifications = (threeMod) => {
    return (
      <>
        <Grid container className={classes.textWrapper}>
          <Grid item sm={4}>
            <RadioGroup
              name={Modification.ThreeMod}
              value={threeModValue}
              onChange={setModData}
            >
              {threeMod.slice(0, 7).map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      disabled={isRadioButtonDisabled(
                        modification,
                        modificationType
                      )}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        messages[modification.displayName]?.defaultMessage ||
                        modification.displayName
                      }
                      key={index}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
          <Grid item sm={4}>
            <RadioGroup
              name={Modification.ThreeMod}
              value={threeModValue}
              onChange={setModData}
            >
              {threeMod.slice(7).map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      disabled={isRadioButtonDisabled(
                        modification,
                        modificationType
                      )}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        messages[modification.displayName]?.defaultMessage ||
                        modification.displayName
                      }
                      key={index}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
        </Grid>
        <div>
          {
            <Grid container className={GlobalCSS.noteInfo}>
              <Grid item xs={1} className={GlobalCSS.InfoText}>
                <InfoIcon
                  aria-label="info"
                  className={GlobalCSS.InfoIcon}
                  color="primary"
                ></InfoIcon>
              </Grid>
              <Grid item xs={11}>
                <FormattedMessage
                  {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
                />
                {productDetails.countryCode !== CountryType.cpeptideJapan ? (
                  <a href={`mailto:${TubeProperties.email}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage
                        {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                      />
                    </span>
                  </a>
                ) : (
                  <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage {...messages.PC_CONTACT_JP_CPEPTIDE} />
                    </span>
                  </a>
                )}
              </Grid>
            </Grid>
          }
        </div>
      </>
    )
  }

  const renderFiveModifications = (fiveMod) => {
    return (
      <>
        <div>
          <ValidationErrors errors={errorValidation} />
        </div>
        <Grid container className={classes.textWrapper}>
          <Grid item sm={4}>
            <RadioGroup
              name={Modification.FiveMod}
              value={fiveModValue}
              onChange={setModData}
            >
              {fiveMod.slice(0, 7).map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      disabled={isRadioButtonDisabled(
                        modification,
                        modificationType
                      )}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        messages[modification.displayName]?.defaultMessage ||
                        modification.displayName
                      }
                      key={index}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
          <Grid item sm={4}>
            <RadioGroup
              name={Modification.FiveMod}
              value={fiveModValue}
              onChange={setModData}
            >
              {fiveMod.slice(7).map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      disabled={isRadioButtonDisabled(
                        modification,
                        modificationType
                      )}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        messages[modification.displayName]?.defaultMessage ||
                        modification.displayName
                      }
                      key={index}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
        </Grid>
        <div>
          {
            <Grid container className={GlobalCSS.noteInfo}>
              <Grid item xs={1} className={GlobalCSS.InfoText}>
                <InfoIcon
                  aria-label="info"
                  className={GlobalCSS.InfoIcon}
                  color="primary"
                ></InfoIcon>
              </Grid>
              <Grid item xs={11}>
                <FormattedMessage
                  {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
                />

                {productDetails.countryCode !== CountryType.cpeptideJapan ? (
                  <a href={`mailto:${TubeProperties.email}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage
                        {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                      />
                    </span>
                  </a>
                ) : (
                  <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage {...messages.PC_CONTACT_JP_CPEPTIDE} />
                    </span>
                  </a>
                )}
              </Grid>
            </Grid>
          }
        </div>
      </>
    )
  }

  const renderWellredModification = (fiveMod) => {
    return (
      <>
        <Grid container className={classes.mgLeft}>
          <Grid item sm={12}>
            <RadioGroup
              name={Modification.FiveMod}
              value={sessionData[currentOligoIndex].fiveMod}
              onChange={setModData}
            >
              {fiveMod.map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        messages[modification.displayName]?.defaultMessage ||
                        modification.displayName
                      }
                      key={index}
                    />
                  </div>
                )
              })}
            </RadioGroup>
            <div>
              <ValidationErrors errors={errorValidation} />
            </div>
          </Grid>
        </Grid>
      </>
    )
  }

  const renderQuencherModifications = (quencherMods) => {
    return (
      <>
        <div>
          <ValidationErrors errors={errorValidation} />
        </div>
        <RadioGroup
          name={Modification.QuencherMod}
          value={reporterQuencherValue}
          onChange={setModData}
          row
        >
          <Grid container className={classes.textWrapper}>
            {lessButton
              ? quencherMods.map((modification, index: number) => {
                  return (
                    <Grid key={modification.value} item xs={4} sm={4}>
                      <FormControlLabel
                        value={modification.value}
                        className={classes.widthFillContent}
                        disabled={isRadioButtonDisabled(
                          modification,
                          modificationType
                        )}
                        control={<StyledRadio isConfiguratorsRedesign="true" />}
                        label={
                          messages[modification.displayName]?.defaultMessage ||
                          modification.displayName
                        }
                        key={index}
                      />
                    </Grid>
                  )
                })
              : quencherMods.slice(0, 9).map((modification, index: number) => {
                  return (
                    <Grid key={modification.value} item xs={4} sm={4}>
                      <FormControlLabel
                        value={modification.value}
                        className={classes.widthFillContent}
                        disabled={isRadioButtonDisabled(
                          modification,
                          modificationType
                        )}
                        control={<StyledRadio isConfiguratorsRedesign="true" />}
                        label={
                          messages[modification.displayName]?.defaultMessage ||
                          modification.displayName
                        }
                        key={index}
                      />
                    </Grid>
                  )
                })}
          </Grid>
        </RadioGroup>
        <div>
          {lessButton ? (
            <Grid container className={GlobalCSS.noteInfo}>
              <Grid item xs={1} className={GlobalCSS.InfoText}>
                <InfoIcon
                  aria-label="info"
                  className={GlobalCSS.InfoIcon}
                  color="primary"
                ></InfoIcon>
              </Grid>
              <Grid item xs={11}>
                <FormattedMessage
                  {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_MSG}
                />
                {productDetails.countryCode !== CountryType.cpeptideJapan ? (
                  <a href={`mailto:${TubeProperties.email}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage
                        {...messages.PC_SEND_FEASIBLITY_AND_QUOTATION_REQUEST}
                      />
                    </span>
                  </a>
                ) : (
                  <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                    <span className={clsx(classes.helpText, classes.helpLink)}>
                      <FormattedMessage {...messages.PC_CONTACT_JP_CPEPTIDE} />
                    </span>
                  </a>
                )}
              </Grid>
            </Grid>
          ) : (
            ''
          )}
        </div>
        <Accordion
          expanded={expanded === 'panel'}
          onChange={handleChange('panel')}
          classes={{ root: classes.panelContainer }}
          className="showMorePanel"
        >
          <AccordionSummary
            classes={{ root: classes.panelSummary, expanded: classes.expanded }}
          >
            {expanded === 'panel' ? (
              <div>
                <FormattedMessage {...messages.CONF_SHOW_LESS} />
                <KeyboardArrowUpIcon className={classes.activePanelIcon} />
              </div>
            ) : (
              <div className={classes.activePanelIcon}>
                {' '}
                <FormattedMessage {...messages.CONF_SHOW_MORE} />{' '}
                <KeyboardArrowDownIcon className={classes.activePanelIcon} />
              </div>
            )}
          </AccordionSummary>
        </Accordion>
      </>
    )
  }

  const disableOnSequenceInvalid = () => {
    if (
      sessionData[currentOligoIndex].sequence !== '' &&
      !isSequenceValid &&
      errorResponseJson &&
      errorResponseJson.secondaryStructure
    ) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }

  React.useEffect(() => {
    disableOnSequenceInvalid()
    //changes for STRAT-16090 start
    if (
      errorResponseJson.listFiveMod &&
      errorResponseJson.listFiveMod.length === 1
    ) {
      if (isSequenceValid) {
        if (
          sessionData[currentOligoIndex].fiveMod !==
          errorResponseJson.listFiveMod[0]
        ) {
          setFiveModValue(errorResponseJson.listFiveMod[0])
          sessionData[currentOligoIndex].fiveMod =
            errorResponseJson.listFiveMod[0]
          errorData.fiveMod = errorResponseJson.listFiveMod[0]
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...state.sessionData],
          })
          dispatch({
            type: 'UPDATE_ERROR_DATA',
            data: { ...state.errorData },
          })
        }
      } else {
        setFiveModValue(defaultFiveMod)
        sessionData[currentOligoIndex].fiveMod = defaultFiveMod
        errorData.fiveMod = defaultFiveMod
      }
    }
    //changes for STRAT-16090 end
    // TODO: need a test before we refactor these dependencies
  }, [errorData, sessionData, errorResponseJson, isSequenceValid])

  React.useEffect(() => {
    if (productDetails.productType === TubeProduct.Aqua) {
      if (sessionData[currentOligoIndex].nterminalMod === '') {
        sessionData[currentOligoIndex].nterminalMod = defaultNterminal
        state.errorData.nterminalMod = defaultNterminal
        setNTerminalModValue(defaultNterminal)
      }
      if (sessionData[currentOligoIndex].cterminalMod === '') {
        setCTerminalModValue(defaultCterminal)
        sessionData[currentOligoIndex].cterminalMod = defaultCterminal
        state.errorData.cterminalMod = defaultCterminal
      }
    }
    if (
      productDetails.productType === TubeProduct.Rna ||
      productDetails.productType === TubeProduct.LongOligo
    ) {
      if (sessionData[currentOligoIndex].fiveMod === '') {
        sessionData[currentOligoIndex].fiveMod = defaultFiveMod
        state.errorData.fiveMod = defaultFiveMod
        setFiveModValue(defaultFiveMod)
      }
      if (sessionData[currentOligoIndex].threeMod === '') {
        sessionData[currentOligoIndex].threeMod = defaultThreeMod
        state.errorData.threeMod = defaultThreeMod
        setThreeModValue(defaultThreeMod)
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  React.useEffect(() => {
    let cterminal: any = ''
    let nterminal: any = ''

    if (productDetails.productType === TubeProduct.Cpeptide) {
      if (sessionData[currentOligoIndex].nterminalMod === '') {
        sessionData[currentOligoIndex].nterminalMod = defaultNterminal
        state.errorData.nterminalMod = defaultNterminal

        setNTerminalModValue(defaultNterminal)
      } else {
        nterminal = sessionData[currentOligoIndex].nterminalMod
        state.errorData.nterminalMod = nterminal
      }

      if (sessionData[currentOligoIndex].cterminalMod === '') {
        setCTerminalModValue(defaultCterminal)
        sessionData[currentOligoIndex].cterminalMod = defaultCterminal
        state.errorData.cterminalMod = defaultCterminal
      } else {
        cterminal = sessionData[currentOligoIndex].cterminalMod
        state.errorData.cterminalMod = cterminal
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isSequenceValid])

  const rendernTerminalModifications = (nterminalMod) => {
    return (
      <>
        <Grid container className={classes.textWrapper}>
          <Grid item sm={5}>
            <RadioGroup
              name="nterminalMod"
              value={nTerminalModValue}
              className={classes.marginArrangement}
              onChange={nTerminalChange}
            >
              {nterminalMod.map((modification, index: number) => {
                return (
                  <div key={index}>
                    <FormControlLabel
                      className={classes.widthFillContent}
                      value={modification.value}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        <FormattedMessage
                          {...checkValidKey(
                            messages[modification.displayName],
                            modification.displayName
                          )}
                        />
                      }
                      key={index}
                      onChange={nTerminalChange}
                      disabled={disabled}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
        </Grid>
        {productDetails.productType === TubeProduct.Cpeptide ? (
          <div className={classes.labelSpacingnterm}>
            {
              <Grid container className={GlobalCSS.noteInfo}>
                <Grid item xs={1} className={GlobalCSS.InfoText}>
                  <InfoIcon
                    aria-label="info"
                    className={GlobalCSS.InfoIcon}
                    color="primary"
                  ></InfoIcon>
                </Grid>
                <Grid item xs={11}>
                  {productDetails.countryCode === CountryType.cpeptideJapan ? (
                    <>
                      <FormattedMessage
                        {...messages.PC_CONTACT_CPEPTIDE_TEXT}
                      />
                      <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                        <span
                          className={clsx(classes.helpText, classes.helpLink)}
                        >
                          <FormattedMessage
                            {...messages.PC_CONTACT_JP_CPEPTIDE}
                          />
                        </span>
                      </a>
                    </>
                  ) : (
                    <>
                      <FormattedMessage
                        {...messages.PC_CONTACT_CPEPTIDE_IL_TEXT}
                      />

                      <a href={`mailto:${TubeProperties.cpeptideEmail}`}>
                        <span
                          className={clsx(classes.helpText, classes.helpLink)}
                        >
                          <FormattedMessage {...messages.PC_CONTACT_CPEPTIDE} />
                        </span>
                      </a>
                    </>
                  )}
                </Grid>
              </Grid>
            }
          </div>
        ) : (
          ''
        )}
      </>
    )
  }

  const rendercTerminalModifications = (cterminalMod) => {
    return (
      <>
        <Grid container>
          <Grid item sm={4}>
            <RadioGroup
              name="cterminalMod"
              value={cTerminalModValue}
              className={classes.marginArrangementCTerminal}
              onChange={cTerminalChange}
            >
              {cterminalMod.map((modification, index: number) => {
                return (
                  <div key={modification.value}>
                    <FormControlLabel
                      value={modification.value}
                      className={classes.widthFillContent}
                      control={<StyledRadio isConfiguratorsRedesign="true" />}
                      label={
                        <FormattedMessage
                          {...checkValidKey(
                            messages[modification.displayName],
                            modification.displayName
                          )}
                        />
                      }
                      key={index}
                      onChange={cTerminalChange}
                      disabled={disabled}
                    />
                  </div>
                )
              })}
            </RadioGroup>
          </Grid>
        </Grid>
        {productDetails.productType === TubeProduct.Cpeptide ? (
          <div className={classes.labelSpacing}>
            {
              <Grid container className={GlobalCSS.noteInfo}>
                <Grid item xs={1} className={GlobalCSS.InfoText}>
                  <InfoIcon
                    aria-label="info"
                    className={GlobalCSS.InfoIcon}
                    color="primary"
                  ></InfoIcon>
                </Grid>
                <Grid item xs={11}>
                  {productDetails.countryCode === CountryType.cpeptideJapan ? (
                    <>
                      <span>
                        <FormattedMessage
                          {...messages.PC_CONTACT_CPEPTIDE_TEXT}
                        />
                      </span>
                      <a href={`mailto:${TubeProperties.cpeptideJPEmail}`}>
                        <span
                          className={clsx(classes.helpText, classes.helpLink)}
                        >
                          <FormattedMessage
                            {...messages.PC_CONTACT_JP_CPEPTIDE}
                          />
                        </span>
                      </a>
                    </>
                  ) : (
                    <>
                      <span>
                        <FormattedMessage
                          {...messages.PC_CONTACT_CPEPTIDE_IL_TEXT}
                        />
                      </span>
                      <a href={`mailto:${TubeProperties.cpeptideEmail}`}>
                        <span
                          className={clsx(classes.helpText, classes.helpLink)}
                        >
                          <FormattedMessage {...messages.PC_CONTACT_CPEPTIDE} />
                        </span>
                      </a>
                    </>
                  )}
                </Grid>
              </Grid>
            }
          </div>
        ) : (
          ''
        )}
      </>
    )
  }

  const callModifications = () => {
    if (
      productDetails.productType === TubeProduct.Rna ||
      productDetails.productType === TubeProduct.LongOligo
    ) {
      if (modificationType === Modification.ThreeMod) {
        return <div>{renderThreeModifications(threeMod)}</div>
      } else {
        return <div>{renderFiveModifications(fiveMod)}</div>
      }
    } else if (
      productDetails.productType === TubeProduct.Aqua ||
      productDetails.productType === TubeProduct.Cpeptide
    ) {
      if (modificationType === Modification.NTerminalMod) {
        return <div>{rendernTerminalModifications(nterminalMod)}</div>
      } else if (modificationType === Modification.CTerminalMod) {
        return <div>{rendercTerminalModifications(cterminalMod)}</div>
      } else {
        return null
      }
    } else if (productDetails.productType === TubeProduct.Wellred) {
      if (modificationType === Modification.FiveMod) {
        return <div>{renderWellredModification(fiveMod)}</div>
      } else {
        return null
      }
    } else {
      return <div>{renderQuencherModifications(quencherMods)}</div>
    }
  }
  return <div className={classes.contentWrapper}>{callModifications()}</div>
}
export default Modifications
